import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { file } from "@planzone/dto";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";

function handleRequest(
  state: State,
  { folder }: Boundaries["downloadFolderContent"]["request"],
): State {
  const index = state.findIndex((req) => req.folder.uuid === folder.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          folder,
          request: setRequestStateToPending(),
          downloadedFolder: folder,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          folder,
          request: setRequestStateToPending(),
          downloadedFolder: folder,
        },
      ];
}

function handleSuccess(
  state: State,
  { folder, downloadedFolder }: Boundaries["downloadFolderContent"]["success"],
): State {
  const index = state.findIndex((req) => req.folder.uuid === folder.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { folder, request: setRequestStateToSuccess(), downloadedFolder },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        { folder, request: setRequestStateToSuccess(), downloadedFolder },
      ];
}

function handleFailure(
  state: State,
  { folder }: Boundaries["downloadFolderContent"]["failure"],
): State {
  const index = state.findIndex((req) => req.folder.uuid === folder.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          folder,
          request: setRequestStateToFailure(),
          downloadedFolder: folder,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          folder,
          request: setRequestStateToFailure(),
          downloadedFolder: folder,
        },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.downloadFolderContentRequested]: handleRequest,
    [events.downloadFolderContentSucceeded]: handleSuccess,
    [events.downloadFolderContentFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
